module.exports = __webpack_public_path__ + "img/img11.0c7c370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img11.png
// module id = 220
// module chunks = 0